import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { OAUTH_URI, ACCOUNTS_URI } from '../config/constants';

import { useLoading } from "../Contexts/LoadingContext";
import { useUser } from "../Contexts/UserContext";

import axios from "axios"

export function GoogleCallback() {
  const navigate = useNavigate();

  const { updateScopes, updateEmailAddress, userSessionId, updateUserSessionId} = useUser();
  const { setLoading } = useLoading();
  
  async function loginGoogleUser(google_auth_code, action, redirect_uri, userSessionId) {
    setLoading(true);
    await axios.post(OAUTH_URI + "/google/token", {google_auth_code, action, redirect_uri, userSessionId}, { withCredentials: true })
      .then((response) => {
        setLoading(false);
        handleResponse(response);
      }).catch((error) => {
        setLoading(false);
        handleError(error);
      });
  }

  function handleResponse(response) {
    console.log("INFO: Response received for google token endpoint ");
    if(response.data.responseCode === 3220) {
        let requestedScopes = response.data.responseData.requestedScopes;
        let emailAddress = response.data.responseData.emailAddress;
        console.log(requestedScopes);
        console.log(emailAddress);
        updateScopes(requestedScopes);
        updateEmailAddress(emailAddress);
        navigate('/scopes');
      }    
  }

  
  function onSignIn(googleUser) {
    console.log("On SignIn");
    var profile = googleUser.getBasicProfile();
    console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
    console.log('Name: ' + profile.getName());
    console.log('Image URL: ' + profile.getImageUrl());
    console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
  }

  function handleError(error) {
    console.log("ERROR: upon calling google token endpoint " + error.message);
    navigate("/error");
  }

  useEffect(() => {

    // Control arrives here upon google logon and callback 
    // URL Search Params Start ****
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    const authCode = params.get("code");
    let state = params.get("state");
    updateUserSessionId(state);
    // URL Search Params End ****
    console.log("Google Code received is: "+authCode);
    console.log("User Session ID obtained in state is: "+state);

    if(authCode) {
        console.log("INFO: GOOGLE Auth Code 'code' obtained from URL Search Params");
        // Auth Code received for further token request with Google oAuth.
        const redirectUri = ACCOUNTS_URI + "/auth/callback";
        loginGoogleUser(authCode, 'GET_AUTH_CODE', redirectUri, state);
    }
    else {
        navigate("/error");
    }
  }, []);

  return <div>Processing login...</div>;
}

